import { MutableRefObject, createContext } from "react"

interface ModalContextValue {
  setIsOpen: (state: boolean) => void
  isOpen: boolean
}

export type CloseHandler = (
  focusableElement?: HTMLElement | MutableRefObject<HTMLElement | null>
) => void
export type CloseRef = MutableRefObject<CloseHandler | null>

interface DisclosureContextValue {
  closeRef: CloseRef
  setLastOpenDisclosure: (state: HTMLButtonElement | null) => void
  lastOpenDisclosure: HTMLButtonElement | null
}

export const HelpModalContext = createContext<ModalContextValue>({} as ModalContextValue)
export const BookNavModalContext = createContext<ModalContextValue>({} as ModalContextValue)

// @TODO: cheating a little bit to avoid having to check if each context value exists
export const DisclosureContext = createContext<DisclosureContextValue>({} as DisclosureContextValue)
